// src/locales/en/language.js
export const language = {
    selectLanguage: "භාෂාව තෝරන්න",
    currentLanguage: "වර්තමාන භාෂාව",
    english: "ඉංග්‍රීසි",
    sinhala: "සිංහල",
    tamil: "දෙමළ"
}